export const baseURL = "https://teenpatti.zekkolive.online/";
export const adminBaseURL = "https://newadmin.zekkolive.online/";
export const key = "SjqWTaltdsBTeGseZXpujUloxZLEglIchxo0ginPhzc=";
